import { z } from 'zod';

import { eventEnvelopeSchema } from './base.js';

export const assistantAiGenerationV1Schema = eventEnvelopeSchema.extend({
  userId: z.string().min(1).max(256),
  properties: z.record(z.unknown()).default({}),
});

export type AssistantAiGenerationV1 = z.infer<typeof assistantAiGenerationV1Schema>;

export const ASSISTANT_AI_GENERATION_V1_DETAIL_TYPE =
  'assistant.ai-generation.v1' as const;
